export const URL = "https://swapi.dev/api/";



// WEBPACK FOOTER //
// ./src/baseURL/baseURL.js